import axios from "axios";

const fileUploadInstance = axios.create();

export default fileUploadInstance;
